import { render, staticRenderFns } from "./baobeishare.vue?vue&type=template&id=6c3914d4&"
import script from "./baobeishare.vue?vue&type=script&lang=js&"
export * from "./baobeishare.vue?vue&type=script&lang=js&"
import style0 from "./baobeishare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3914d4')) {
      api.createRecord('6c3914d4', component.options)
    } else {
      api.reload('6c3914d4', component.options)
    }
    module.hot.accept("./baobeishare.vue?vue&type=template&id=6c3914d4&", function () {
      api.rerender('6c3914d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/xinfang/baobeishare.vue"
export default component.exports